import Base from './Base';
import gsap from 'gsap'
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';
import { evt, utils, store } from '@/core';

const { qs, qsa } = utils;
const { dom, bounds } = store;

export default class extends Base {
  onEnter() {
    super.onEnter();    
    console.log('Entra')
  }

  onLeave() {
    super.onLeave();
  }

  onEnterCompleted() {
    super.onEnterCompleted();  

    const swiperHome = qs(".home-swiper")
    
    swiperHome &&
    new Swiper(swiperHome, {
      spaceBetween:0,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 6500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });

    // Card Swiper
    const swiperCards = qs(".cards-swiper")
    
    swiperCards &&
    new Swiper(swiperCards, {
      spaceBetween:20,
      slidesPerView: 'auto',
      //allowTouchMove: false,
      loop: true,
      freeMode: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 6000,
      //slideToClickedSlide: true,
      // autoplay: {
      //     delay: 1500,
      //     disableOnInteraction: false,
      // },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true
      // },
    });

    const tabsNavButtons = qsa('.tabs-nav button');
    const tabs = qsa('#tab > div');
    tabsNavButtons &&
    tabsNavButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const rel = button.getAttribute('data-rel');
        const tab = qs('#' + rel);
        if (!button.classList.contains('active')) {
          tabsNavButtons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
        }
      });
    });
    
    const popUpbutton = qs('.popup-btn');
    const popUp = qs('.popup');
    const popUpVideo = qs('.popup video');
    const popUpClose = qs('.popup-close');
    popUpbutton && popUpbutton.addEventListener('click', (e) => {
      e.preventDefault();
      popUp.classList.add('active');
    });
    popUpClose && popUpClose.addEventListener('click', (e) => {
      e.preventDefault();
      popUp.classList.remove('active');
      popUpVideo.pause();
    });
    popUp && popUp.addEventListener('click', (e) => {
      if (e.target === popUp) {
        popUp.classList.remove('active');
        popUpVideo.pause();
      }
    });   

    //marquee
    /*
    const logos = document.querySelectorAll('.logo-marquee');
    gsap.set(logos, { autoAlpha: 1 })

    logos.forEach((logo, i) => {
      gsap.set(logo, { xPercent: 100 * i });
    });
    if (logos.length > 5) {

      const logosWrap = gsap.utils.wrap(-100, ((logos.length - 1) * 100));
      
      const duration = logos.length * 4.5;

      gsap.to(logos, {
        xPercent: `-=${logos.length * 100}`,
        duration,
        repeat: -1,
        ease: 'none',
        modifiers: {
          xPercent: xPercent => logosWrap(parseFloat(xPercent))
        }
      });

    }
    //marquee Invert
    const logosInvert = document.querySelectorAll('.logo-marquee-invert');
    gsap.set(logosInvert, { autoAlpha: 1 })

    logosInvert.forEach((logo, i) => {
      gsap.set(logo, { xPercent: 100 * i });
    });
    if (logosInvert.length > 5) {
      
      const logosInvertWrap = gsap.utils.wrap(-100, ((logosInvert.length - 1) * 100));
      
      const duration = logosInvert.length * 4.5;

      gsap.to(logosInvert, {
        xPercent: `+=${logosInvert.length * 100}`,
        duration,
        repeat: -1,
        ease: 'none',
        modifiers: {
          xPercent: xPercent => logosInvertWrap(parseFloat(xPercent))
        }
      });

    }
    */

  }

  onLeaveCompleted() {
    super.onLeaveCompleted();
  }

}
